import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadFile, closeCollapsible, translate, formatDateToPtbr, getUserNameToName, isNullOrEmpty } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Collapsible, Table, Modal } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const PartNumberContainer = (props) => {
    const [containers, setContainers] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [filter, setFilter] = useState({ internal: false });

    useEffect(() => {
        // if (!isNullOrEmpty(filter.partnumber)) {
        setContainers(props.containersItemPaged?.items || []);
        //}
        // eslint-disable-next-line
    }, [props?.containersItemPaged?.items]);

    useEffect(() => {
        //if (!isNullOrEmpty(filter.partnumber)) {
        onSearch(false);
        //}
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getContainers({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `desenhoxcontainer${Date.now()}.csv`, "data:text/csv", false);
        })
    }


    const configColumn = () => {
        const cols = [
            {
                field: 'partNumber',
                header: translate('container:fields:items:partNumber'),
                align: 'left',
                sortable: false
            },
            {
                field: 'partNumberDescription',
                header: 'Descrição',
                align: 'left',
                sortable: false
            },
            {
                field: 'baiCode',
                header: "Nº Caixa Pai",
                align: 'left',
                sortable: false
            },
            {
                field: 'name',
                body: (rowData) => rowData.container.name,
                header: 'Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'lotNumber',
                header: translate('container:fields:items:lot'),
                align: 'left',
                sortable: false
            },
            {
                field: 'location',
                body: (rowData) => rowData.container.location,
                header: 'Posição',
                align: 'left',
                sortable: true
            },
            {
                field: 'statusDescription',
                body: (rowData) => rowData.container.statusDescription,
                header: 'Status',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy || rowData.createdBy),
                align: 'left',
            }
        ];
        return cols;
    };




    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: translate('container:search:menu.search-partnumber') }} />
            <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => exportCsv()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s10">
                                            <Input
                                                id="partnumber"
                                                name='partnumber'
                                                label='Desenho'
                                                type="text"

                                                value={filter?.partnumber || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />

                </div>

                <Table
                    totalPages={props.containers?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={containers}
                    noRows='Material não encontrado em nenhum container dentro do sistema.'
                />

            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        containersItemPaged: state.containerReducer.containersItemPaged,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainers: (filter) => {
            dispatch(ContainerService.getContainerItemPaged(filter));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportContainerItemCsv(filter, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartNumberContainer));
